import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdministrativeReportsService {

  private baseUrl = environment.apiBaseUrl + '/spring';

  constructor(private http: HttpClient) { }

  generateReport(r: any): Observable<any>{
    return this.http.post(`${this.baseUrl}/AdministrativeReports/generate`,r,{ responseType: 'blob'});
	}
}
